import { render, staticRenderFns } from "./SendTransactionForm.vue?vue&type=template&id=7c1e925c&"
import script from "./SendTransactionForm.vue?vue&type=script&lang=js&"
export * from "./SendTransactionForm.vue?vue&type=script&lang=js&"
import style0 from "./SendTransactionForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports